import React, { useState } from 'react';
import './Header.css'; 
import logo from '../assets/images/logo.svg';
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`Header ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="logo">
        <Link to="/" onClick={() => setIsMenuOpen(false)}>
          <img src={logo} alt="SpaceTimeAI Logo" />
        </Link>
      </div>

      <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle Menu">
        <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
      </button>

      <nav className={`nav-links ${isHomePage ? 'home-page' : ''} ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><a className={isHomePage ? 'white-text' : 'black-text'} href="/">Home</a></li>

          <li className="dropdown">
            <a className={isHomePage ? 'white-text' : 'black-text'} href="/solutions">
              Solutions
            </a>
            <ul className="dropdown-menu">
              <li><Link to="/solutions/spacetime-city-twin">Spacetime CityTwin</Link></li>
              <li><Link to="/solutions/spacetime-safe-city">Spacetime SafeCity</Link></li>
              <li><Link to="/solutions/spacetime-infra-plan">Spacetime InfraPlan</Link></li>
            </ul>
          </li>

          <li className="dropdown">
             <a className={isHomePage ? 'white-text' : 'black-text'} href="/success-stories">
              Success Stories
            </a>
            
            <ul className="dropdown-menu-success-stories">
              <li><Link to="/success-stories?filter=europe"> Europe</Link></li>
              <li><Link to="/success-stories?filter=asia">Asia</Link></li>
              <li><Link to="/success-stories?filter=north_america"> North America</Link></li>
              <li><Link to="/success-stories">All Stories</Link></li>
            </ul>
          </li>

          <li><a className={isHomePage ? 'white-text' : 'black-text'} href="/about">About</a></li>
          <li><a className={isHomePage ? 'white-text' : 'black-text'} href="/contact">Contact</a></li>
        </ul>
      </nav>

      {/* 语言选择器 */}
      {/*
      <div className={`language-selector ${isHomePage ? 'home-page' : ''}`}>
        <button className={isHomePage ? 'white-text' : 'black-text'}>EN</button>
      </div>
    */}
    </header>
  );
}

export default Header;